import script from "./NotificationsCenter.vue?vue&type=script&lang=js"
export * from "./NotificationsCenter.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__